module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-adnkronos.e4c35026ef4f6d58c4a806f2d7f5a7bb.png";